
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CPLegal extends Vue {
  public year: number = new Date().getFullYear();
}
